import TextField from '@mui/material/TextField';
import InfoPopup from './InfoPopup.jsx';
import { useState, useEffect } from 'react';

// Component for all emailfields in the form

export default function EmailField({ id, email, emailCanBeEdited, onChange, onValidationChange }) {

  // Simple validation of email address
  const [touched, setTouched] = useState(false);
  const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) || email.length === 0;
  const showError = touched && !isValidEmail(email);
  
  useEffect(() => {
      if (onValidationChange) {
        onValidationChange(isValidEmail(email));
      }
    }, [email, onValidationChange]);


  return (
    <div style={{ width: '100%', marginBottom: '8px' }}>
      <label
        htmlFor={id}
        style={{
          display: 'flex',
          alignItems: 'center',
          textAlign: 'left',
          fontWeight: 600,
          marginBottom: 15,
          marginTop: 20,
          fontFamily: 'Finlandica-Regular, Arial, sans-serif',
          fontSize: '18px',
          color: '#000000',
          paddingLeft: '12px',
          gap: '15px',
        }}
      >
        Lipun käyttäjän sähköposti:
        <InfoPopup style={{display: emailCanBeEdited ? 'flex' : 'none'}}/>
      </label>
      <TextField
        id={id}
        label="Sähköposti"
        variant="outlined"
        disabled={!emailCanBeEdited}
        value={email}
        onChange={onChange}
        onBlur={() => setTouched(true)}
        error={showError}
        fullWidth
        size="small"
        sx={{
          background: '#f5f5f5',
          borderRadius: '4px',
        }}
      />
    </div>
  );
}